import React from "react";
import { useState } from "react";
import Footer from "../../components/footer";
import Gotop from "../../components/gotop";
import LoginHeader from "../../components/header/LoginHeader";
import MobileHeader from "../../components/header/MobileHeader";
import AlertCard from "./AlertCard";
import LoginMobileHeader from "../../components/header/LoginMobileHeader";
import InstituteMobileHeader from "../../components/header/InstituteMobileHeader";
import CRMobileHeader from "../../components/header/CRMobileHeader";
import InstituteHeader from "../../components/header/InstituteHeader";
import CRHeader from "../../components/header/CRHeader";
import NonLoginHeader from "../../components/header/NonLoginHeader";

AlertJobs.propTypes = {};

function AlertJobs(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  const module =localStorage.getItem("Module")
  return (
    <>
      
      {module === 'Candidate' ? <LoginMobileHeader handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteMobileHeader handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRMobileHeader handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRMobileHeader handleMobile={handleMobile} /> :
                            <MobileHeader handleMobile={handleMobile} />}
            {module === 'Candidate' ? <LoginHeader clname="applications" handleMobile={handleMobile} /> :
                module === 'Institution' ? <InstituteHeader clname="applications" handleMobile={handleMobile} /> :
                    module === 'Company' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                        module === 'Recruiter' ? <CRHeader clname="applications" handleMobile={handleMobile} /> :
                            <NonLoginHeader clname="applications" handleMobile={handleMobile} />}


      <div className="pt-70">

      <AlertCard />

     </div>
      {/* <Footer /> */}
      {/* <Gotop /> */}
    </>
  );
}

export default AlertJobs;



